import styled, { css } from 'styled-components';

export const ErrorMessageLabel = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-left: 10px;
  color: ${({ theme }) => theme.palette.tomato};
`;

const showIconMixin = ({ showIcon = true }) =>
  showIcon
    ? css`
        svg,
        path {
          fill: ${({ theme }) => theme.palette.tomato};
          font-size: 16px;
        }
      `
    : css`
        svg {
          display: none;
        }
        ${ErrorMessageLabel} {
          margin-left: 0px;
        }
      `;

export const ErrorMessageWrapper = styled.div<{ showIcon?: boolean }>`
  display: flex;
  align-items: center;
  ${showIconMixin}
`;
